import serviceBase from '@/services/serviceBase'

class perfilService extends serviceBase {
    constructor() {
        super(process.env.VUE_APP_API_ENDPOINT)
    }

    fetch() {
        return this.get(`${ this.getSubdominio() }/configuracao`)
    }
}

export default new perfilService()